export class orderBookModel {
setValue(res){
if(res){
}
}
}